const getCropFormat = ({ enableCrops, isMobileOrTablet }) => {
  if (enableCrops !== true) {
    return null;
  }
  return isMobileOrTablet ? '1x1' : '3x2';
};

export default getCropFormat;
